import { apiClient } from '../utils/apiClient';
const ENDPOINTS = {
    SUMMARY: '/summary/',
    INIT_CAPTURE: '/init_capture/',
    UPLOAD_CONFIRMATION: '/upload_confirmation/',
};
export const verificationService = {
    async fetchSummary(tokenSource, flow) {
        return apiClient.post(ENDPOINTS.SUMMARY, { tokenSource, flow });
    },
    async initCapture(request) {
        return apiClient.post(ENDPOINTS.INIT_CAPTURE, request);
    },
    async confirmUpload(request) {
        return apiClient.post(ENDPOINTS.UPLOAD_CONFIRMATION, request);
    },
};
//# sourceMappingURL=verificationService.js.map